// document.addEventListener('DOMContentLoaded', function(){
//   const toggle = document.querySelector('[data-mobile-menu-toggle]');
//   const nav = document.querySelector('[data-mobile-nav]');
//   if(toggle && nav){
//     toggle.addEventListener('click', function(){
//       nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
//     });
//   }
// });


document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
    });
  }

  // Rotating announcement bar
  var track = document.querySelector('.announcement-track');
  if (track) {
    var items = track.querySelectorAll('.announcement-item');
    if (items.length > 1) {
      var current = 0;
      items.forEach(function (item, i) {
        item.style.display = i === 0 ? 'inline' : 'none';
      });
      setInterval(function () {
        items[current].style.display = 'none';
        current = (current + 1) % items.length;
        items[current].style.display = 'inline';
      }, 4000);
    }
  }
});
